// extracted by mini-css-extract-plugin
export var md = "768px";
export var questionContainer = "Question_questionContainer__R42il";
export var questionDisclaimer = "Question_questionDisclaimer__HJD8o";
export var questionLabel = "Question_questionLabel__50c3i";
export var questionLabelContainer = "Question_questionLabelContainer__OZNt9";
export var questionSubLabel = "Question_questionSubLabel__pCXR4";
export var radioColorQuestion = "Question_radioColorQuestion__KBhgg";
export var shared = "\"../../../shared.module.css\"";